import { FC } from 'react';
import { isArray } from '@lhb/func';
// import { Typography } from 'antd';
import { ApprovalNodeOperatorStatus } from '@/common/components/business/ExpandStore/ts-config';
import cs from 'classnames';
import styles from './index.module.less';
import NodeOperatorName from './NodeOperatorName';
import NodeOpinion from './NodeOpinion';
import { getStartNodeReasonParts } from './config';
// const { Text } = Typography;

/**
 * @Description 审批节点item
 */
const NodeItem: FC<{
  /** 审批节点 */
  node: any;
}> = ({
  node
}) => {
  const { operators } = node;
  // 拒绝 || 驳回
  const isFail = (operatorStatus: any) => {
    return operatorStatus === ApprovalNodeOperatorStatus.Denied || operatorStatus === ApprovalNodeOperatorStatus.Reject;
  };

  // const labelWidth = (str: string) => {
  //   const len = str?.length;
  //   if (len <= 7) {
  //     return 18 * len;
  //   }
  //   return 145;
  // };

  const getReasonText = (operator: any) => {
    const { closeReasonName, reason } = getStartNodeReasonParts({
      isStart: node?.isStart,
      closeReasonName: node?.closeReasonName,
      reason: operator?.reason,
    });

    if (!closeReasonName) return reason;

    return <>
      <span style={{ fontWeight: 500 }}>{closeReasonName}</span>
      <span> 审批理由： {reason}</span>
    </>;
  };

  return <>
    {/* 遍历操作人 */}
    { isArray(operators) && operators?.length > 0
      ? <>
        {
          operators.map((item: any, index: number) => <div
            key={index}
            className={styles.nodeItemCon}
          >
            {/* 操作人首字及小icon */}
            <NodeOperatorName
              node={node}
              operator={item}
              name={item.employeeName}
            />
            {/* 审批人和审批时间 */}
            <div className={cs(styles.contentCon, 'ml-8')}>
              <div className={cs(
                'c-222 fs-14 bold',
                item?.operateAt ? '' : 'mt-10'
              )}>
                {item?.employeeName}
                {
                  isFail(item?.status)
                    ? <span className='pl-4 c-f23'>{item?.statusName}</span>
                    : null
                }
              </div>
              {/* 操作时间 */}
              {
                item?.operateAt ? <div className='c-666 fs-12'>
                  {item?.operateAt}
                </div> : <></>
              }
              {/* 申请理由 || 审批意见 */}
              {
                item?.reason || (isArray(item?.cusFields) && item.cusFields[0] && item.cusFields[0].name) ? <NodeOpinion
                  text={<>
                    {
                      isArray(item?.cusFields) && item.cusFields[0] && item.cusFields[0].name ? <>
                        <div className={styles.flexCon}>
                          <div style={{ flexShrink: 0 }}>
                            {/* <Text
                              style={{ width: labelWidth(item.cusFields[0].name) }}
                              ellipsis={{ tooltip: item.cusFields[0].name }}>
                              <span>
                                {item.cusFields[0].name}：
                              </span>
                            </Text> */}
                            {item.cusFields[0].name}：
                          </div>
                          <div className={styles.textAreaCon}>
                            {item.cusFields[0].value}
                          </div>
                        </div>
                        <div className={cs(styles.flexCon, 'mt-8')}>
                          <div style={{ flexShrink: 0 }}>审批意见：</div>
                          <div className={styles.textAreaCon}>
                            {item?.reason}
                          </div>
                        </div>
                      </> : <div className={styles.textAreaCon}>{getReasonText(item)}</div>
                    }
                  </>}
                  isStart={node?.isStart}
                /> : <></>
              }
            </div>
          </div>)
        }
      </>
      : <></> }
  </>;
};

export default NodeItem;
